export class Testimonial {
	public name: string;
	public initials: string;
	public position: string;
	public image?: string | null;
	public content: string;
	public video?: string | null;

	constructor(testimonial: Testimonial) {
		Object.assign(this, testimonial);
	}
}
